import React, { useEffect, useState } from 'react';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../../../../components/Component';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import * as app_consts from "../../../../utils/app_consts";
import { TENANT_ADD_EMPLOYEES_TO_TENANT_PROMOTION_MODULE_API, TENANT_RETRIEVE_PROMOTION_MODULE_EMPLOYEES_API, TENANT_RETRIEVE_PROMOTION_PROFILE_ROLES_API } from '../../../../api/api_data';
import { fail_retrieve_tenant_profiles_list, loading_retrieve_tenant_profiles_list, reset_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list } from '../../../../reducers/auth_tenant/retrieve_tenant_profiles_list_Slice';
import { ADD_EMPLOYEE_TO_TENANT_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_SUCCESS_MSG, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import moment from 'moment';
import { Alert, Badge, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import TextInput from '../../../components/inputs/TextInput';
import PhoneInput from 'react-phone-input-2';
import { fail_retrieve_tenant_profile_roles, loading_retrieve_tenant_profile_roles, reset_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles } from '../../../../reducers/auth_tenant/retrieve_tenant_profile_roles_Slice';
import { fail_add_employee_to_tenant, loading_add_employee_to_tenant, reset_add_employee_to_tenant, success_add_employee_to_tenant } from '../../../../reducers/auth_tenant/add_employee_to_tenant_Slice';
import AuthTenantNoData from '../../../error/AuthTenantNoData';

const initalState = { first_name: "", last_name: "", mobile_number: "", email_address: "", roles: [], position: "", department: "" };

const PromotionsEmployees = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [employees, setEmployees] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [sm, updateSm] = useState(false);
  const [add_employee_modal, setAddEmployeeModal] = useState(false);
  const [add_employee_error, setAddEmployeeError] = useState("");
  const [add_employee_loading, setAddEmployeeLoading] = useState(false);
  const [formData, setFormData] = useState(initalState);
  const [tenant_profile_roles, setTenantProfileRoles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    retrieve_employee_list();
  }, []);

  const retrieve_employee_list = () => {
    setError("");
    setLoading(true);
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profiles_list, success_retrieve_tenant_profiles_list, fail_retrieve_tenant_profiles_list, RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG, RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_MODULE_EMPLOYEES_API}`));
  };

  // Listener
  const retrieve_tenant_profiles_list_listener = useSelector((state) => state.retrieve_tenant_profiles_list.retrieve_tenant_profiles_list);

  useEffect(() => {
    if (retrieve_tenant_profiles_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_profiles_list_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_profiles_list_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_profiles_list_listener.message);
          messageToast(retrieve_tenant_profiles_list_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_profiles_list_listener.status === app_consts.SUCCESS)
        {
          setEmployees(retrieve_tenant_profiles_list_listener.data);
          setCurrentPageData(retrieve_tenant_profiles_list_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_profiles_list());
      }
    }
  }, [retrieve_tenant_profiles_list_listener]);

  const close_add_employee_modal = () => {
    setAddEmployeeModal(false);
    setAddEmployeeError("");

  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRowChange = (role) => {
    let new_roles = formData?.roles || [];

    if (new_roles?.includes(role))
    {
      new_roles = new_roles?.filter((ro) => ro !== role);
    } else
    {
      new_roles.push(role); // Just push the role without re-assigning to new_roles
    }

    setFormData({ ...formData, roles: new_roles });
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);


  // Open Add Employee Modal
  const open_add_employee_modal = () => {
    setAddEmployeeModal(true);
    setAddEmployeeError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles, fail_retrieve_tenant_profile_roles, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_PROFILE_ROLES_API}`));
  };

  // Listener
  const retrieve_tenant_profile_roles_listener = useSelector((state) => state.retrieve_tenant_profile_roles.retrieve_tenant_profile_roles);

  useEffect(() => {
    if (retrieve_tenant_profile_roles_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_profile_roles_listener.status === app_consts.LOADING)
      {
        console.log("Tenant Profile Roles Loading");
      } else
      {
        if (retrieve_tenant_profile_roles_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_tenant_profile_roles_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_profile_roles_listener.status === app_consts.SUCCESS)
        {
          setTenantProfileRoles(retrieve_tenant_profile_roles_listener.data);
        }
        dispatch(reset_retrieve_tenant_profile_roles());
      }
    }
  }, [retrieve_tenant_profile_roles_listener]);

  const handleSubmit = () => {
    setAddEmployeeError("");
    dispatch(tenant_auth_actions_helper(loading_add_employee_to_tenant, success_add_employee_to_tenant, fail_add_employee_to_tenant, ADD_EMPLOYEE_TO_TENANT_ERROR_MSG, ADD_EMPLOYEE_TO_TENANT_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_ADD_EMPLOYEES_TO_TENANT_PROMOTION_MODULE_API}`, formData));
  };
  // Listener
  const add_employee_to_tenant_listener = useSelector((state) => state.add_employee_to_tenant.add_employee_to_tenant);

  useEffect(() => {
    if (add_employee_to_tenant_listener.status !== app_consts.IDLE)
    {
      if (add_employee_to_tenant_listener.status === app_consts.LOADING)
      {
        setAddEmployeeLoading(true);
        setAddEmployeeError("");
      } else
      {
        if (add_employee_to_tenant_listener.status === app_consts.FAIL)
        {
          setAddEmployeeError(add_employee_to_tenant_listener.message, app_consts.FAIL);
          messageToast(add_employee_to_tenant_listener.message, app_consts.FAIL);
        } else if (add_employee_to_tenant_listener.status === app_consts.SUCCESS)
        {
          close_add_employee_modal();
          retrieve_employee_list();
        }
        setAddEmployeeLoading(false);
        dispatch(reset_add_employee_to_tenant());
      }
    }
  }, [add_employee_to_tenant_listener]);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_employees(searchTerm);
  }, [searchTerm]);

  const filtered_employees = (searchItem) => {
    if (searchItem)
    {
      let displayedEmployees;

      displayedEmployees = employees?.filter((item) => {
        const combinedParams = [
          item?.user?.first_name,
          item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--",
          item?.user?.last_name,
          item?.account?.mobile_number,
          item?.account?.email_address,
          item.department,
          item.position,
          item.department,
          item.department,
          item?.profile?.inserted_at ? moment(item?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedEmployees);
    } else
    {
      setCurrentPageData(employees);
    }
  };

  return (
    <>
      <Head
        title={
          tenant_info?.name ? `${tenant_info.name} Employees` : ' Employees'
        }
      />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Employees</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Employees ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_employee_list();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          value={searchTerm}
                          onChange={e => setSearchTerm(e.target.value)}
                          placeholder="Search for Employees"
                        />
                      </div>
                    </li>
                    {
                      user_info?.roles?.includes(app_consts.ADMINISTRATOR) && (
                        <>
                          <li className="nk-block-tools-opt">
                            <Button
                              className="toggle btn-icon d-md-none"
                              color="primary"
                              onClick={() => {
                                open_add_employee_modal();
                              }}
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                            <Button
                              className="toggle d-none d-md-inline-flex"
                              color="primary"
                              onClick={() => {
                                open_add_employee_modal();
                              }}
                            >
                              <Icon name="plus"></Icon>
                              <span>Add Employee</span>
                            </Button>
                          </li>
                        </>
                      )
                    }
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Employees..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      employees && employees?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Username</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Department</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Position</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Date Created</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Last Login</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.account?.email_address || "--"}  | {item?.account?.mobile_number || "--"} </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.profile?.department}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.profile?.position}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.profile?.inserted_at ? moment(item?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-date">{item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.profile?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "danger"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.profile?.status?.toUpperCase() || "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>


                          < Modal isOpen={add_employee_modal} className="modal-dialog-centered" size={"lg"} >
                            <ModalHeader toggle={add_employee_loading ? "" : close_add_employee_modal}>Add Employee</ModalHeader>
                            <ModalBody>
                              <Row className="g-4">
                                <TextInput
                                  label="First Name"
                                  type="text"
                                  id_val="first_name"
                                  value={formData.first_name}
                                  colSize="6"
                                  name="first_name"
                                  handleChange={handleChange}
                                  required
                                />
                                <TextInput
                                  label="Last Name"
                                  type="text"
                                  id_val="last_name"
                                  value={formData.last_name}
                                  colSize="6"
                                  name="last_name"
                                  handleChange={handleChange}
                                  required
                                />
                                <Col lg="6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label" htmlFor="mobile_number">
                                        Mobile Number<span className='text-danger pr-2'>{`* `}</span>
                                      </label>
                                    </div>
                                    <div className="form-control-wrap">
                                      <PhoneInput
                                        country={"zm"}
                                        value={formData.mobile_number}
                                        onChange={(phone) => setFormData({ ...formData, ["mobile_number"]: phone })}
                                        copyNumbersOnly={false}
                                        inputStyle={{ width: '100%' }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                                <TextInput
                                  label="Email Address"
                                  type="text"
                                  id_val="email_address"
                                  value={formData.email_address}
                                  colSize="6"
                                  name="email_address"
                                  handleChange={handleChange}
                                  required
                                />
                                <TextInput
                                  label="Department"
                                  type="text"
                                  id_val="department"
                                  value={formData.department}
                                  colSize="6"
                                  name="department"
                                  handleChange={handleChange}
                                  required
                                />
                                <TextInput
                                  label="Position"
                                  type="text"
                                  id_val="position"
                                  value={formData.position}
                                  colSize="6"
                                  name="position"
                                  handleChange={handleChange}
                                  required
                                />
                                {/* Roles */}

                                <div className="form-group">
                                  <label className="form-label">Roles<span className='text-danger pr-2'>{`* `}</span></label>
                                  <ul className="custom-control-group g-3 align-center">

                                    {
                                      tenant_profile_roles && tenant_profile_roles?.length > 0 && tenant_profile_roles?.map((role) => {
                                        return (
                                          <>
                                            <li>
                                              <div className="custom-control custom-control-sm custom-checkbox">
                                                <input onChange={() => handleRowChange(role)} checked={formData?.roles?.includes(role)} type="checkbox" className="custom-control-input" id={role} />
                                                <label className="custom-control-label" style={{ fontSize: "18px" }} htmlFor={role}>
                                                  {formatToSentenceCase(role)}
                                                </label>
                                              </div>
                                            </li>
                                          </>
                                        );
                                      }
                                      )}
                                  </ul>
                                </div>
                                {add_employee_error && (
                                  <div className="mb-3 w-100">
                                    <Alert color="danger" className="alert-icon">
                                      <Icon name="alert-circle" /> {add_employee_error}{" "}
                                    </Alert>
                                  </div>
                                )}
                                <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                  <Button onClick={handleSubmit} disabled={add_employee_loading || !(formData?.first_name && formData?.last_name && formData?.email_address && formData?.roles?.length > 0 && formData?.position && formData?.department && formData?.mobile_number)} color="primary">
                                    {add_employee_loading ? <Spinner size="sm" color="light" /> : "Add Employee"}
                                  </Button>
                                </Col>
                              </Row>
                            </ModalBody>
                          </Modal>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Employees Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default PromotionsEmployees;